import React, { useCallback, useState } from 'react';
import { UserBookCreateGuide } from './UserBookCreateGuide';
import { UserBookCreateForm } from './UserBookCreateForm';
import { UserBookCreativeGuide } from './UserBookCreativeGuide';
import { useQuery } from '@tanstack/react-query';
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { UserBookCreateMaxGuide } from './UserBookCreateMaxGuide';
import { ErrorMessageBox, Loading } from 'bf-library';

/**
 * 작품의 생성만 담당한다.
 * 제목수정은 Modify를 찾아보자
 */
export const UserBookCreate = () => {
    const [step, setStep] = useState(1);
    const [creative, setCreative] = useState('Y');

    const { data: mySummary, isSuccess, isFetching, isError, error } = useQuery({
        queryKey: ['user/book/my/summary'],
        queryFn: () => Api.get('/api/userBook/summary')
    });

    const onNextStep = useCallback((isCreative, step = 2) => {
        setCreative(isCreative);
        setStep(step);
    }, []);

    const onCancel = useCallback(() => {
        setStep(1);
    }, []);

    if (isError) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;

    if (isSuccess && mySummary?.data?.total - mySummary?.data?.complete >= 10) {
        return <UserBookCreateMaxGuide summary={mySummary?.data} />
    }

    return (
        <div className="userBookCreate">
            {step === 1 && <UserBookCreateGuide onNextStep={onNextStep} />}
            {step === 2 && <UserBookCreativeGuide onNextStep={onNextStep} onCancel={onCancel} />}
            {step === 3 && <UserBookCreateForm creative={creative} onCancel={onCancel} />}
            <Loading overlay={true} active={isFetching} />
        </div>
    );
};